export default {
  menu: {
    auth: 'Dynamic Residential Agency',
    subaccount: 'Sub-accounts',
    trafficRecord: 'Traffic Records',
    purchaseOnline: 'Purchase Online',
    dynamicPurchase: 'Dynamic Residential Purchase',
    recordQuery: 'Record Query',
    flowChangeRecord: 'Traffic Change Log',
    loginRecord: 'Login Records',
    proxyCheck: 'Proxy Check',
    personalCenter: 'Personal Center',
    personalSettings: 'Personal Settings',
    logout: 'Logout',
    accountSettings: 'Account Settings',
    home: 'Home',
    dynamicProxy: 'Dynamic Residential Proxy',
    helpCenter: 'Help Center',
    login: 'Login',
    register: 'Register',
    dashboard: 'Dashboard',
    staticProxy: 'Static Residential Proxy',
    staticList: 'Static List',
    staticPurchase: 'Native Static Purchase',
    broadcastPurchase: 'Broadcast Static Purchase',
    customerService: 'Contact Customer Service'
  },
  header: {
    logoutSuccess: 'Logout successful'
  },
  login: {
    welcomeBack: 'Welcome Back',
    signInToContinue: 'Sign in to continue',
    usernamePlaceholder: 'Username / Email',
    passwordPlaceholder: 'Password',
    captchaPlaceholder: 'Captcha',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot Password?',
    loginBtn: 'Login',
    noAccount: 'Don\'t have an account?',
    registerNow: 'Register Now',
    slogan: 'Connect the world, enjoy unlimited possibilities',
    loginSuccess: 'Login successful',
    loginFailed: 'Login failed',
    getCaptchaFailed: 'Failed to get captcha',
    inputUsername: 'Please enter username',
    inputPassword: 'Please enter password',
    inputCaptcha: 'Please enter captcha'
  },
  register: {
    createAccount: 'Create Account',
    subtitle: 'Free registration, start your global proxy journey',
    usernamePlaceholder: 'Username',
    passwordPlaceholder: 'Set Password',
    confirmPasswordPlaceholder: 'Confirm Password',
    registerBtn: 'Register Now',
    hasAccount: 'Already have an account?',
    loginNow: 'Login Now',
    inputUsername: 'Please enter username',
    usernameMinLength: 'Username must be at least 3 characters',
    inputPassword: 'Please enter password',
    inputConfirmPassword: 'Please confirm password',
    passwordMismatch: 'Passwords do not match!',
    inputCaptcha: 'Please enter captcha',
    registerSuccess: 'Registration successful!',
    registerFailed: 'Registration failed',
    registerFailedRetry: 'Registration failed, please try again'
  },
  home: {
    hero: {
      title: 'Global Residential IP Service Provider',
      subtitle: 'Integrating real residential IPs, gathering IP resource pools, constantly updating IPs<br />Access from countries and regions around the world to help your business go global',
      buyNow: 'Buy Now',
      contactSales: 'Contact Sales'
    },
    banner: {
      global: 'Global Coverage',
      globalDesc: 'Precise targeting in 190+ regions',
      safe: 'High Anonymity',
      safeDesc: '99.9% stable uptime',
      exclusive: 'Exclusive Resources',
      exclusiveDesc: 'Trusted by 10,000+ enterprises',
      support: 'Instant Support',
      supportDesc: '24/7 real-time help'
    },
    stats: {
      ipPool: 'Global IP Pool',
      dailyUpdate: 'Daily Updates',
      successRate: 'Global Success Rate',
      locations: 'Countries/Regions'
    },
    features: {
      title: 'Core Advantages',
      subtitle: 'Integrating top technology to build a stronger experience',
      concurrency: 'High Concurrency',
      concurrencyDesc: 'Exclusive high-performance servers, accessing with real residential addresses, maintaining normal proxy connections with unlimited concurrency.',
      resources: 'Premium IP Resources',
      resourcesDesc: 'Integrating real residential IPs, gathering IP resource pools, constantly updating IPs, accessing from countries and regions around the world.',
      diversity: 'Diverse Forms',
      diversityDesc: 'Multiple proxy authentication modes to help accounts set up flexibly, supporting username/password mode and API whitelist mode.',
      service: 'Technical Service',
      serviceDesc: 'Support business scenario customization for exclusive IPs, gigabit ultra-high-speed bandwidth, and customizable export IP duration.'
    },
    product: {
      badge: 'Hot Product',
      title: 'Dynamic Residential Proxy',
      desc: 'Dynamic Residential Proxy Network is a proxy network containing real IP addresses provided by Internet Service Providers (ISPs). These IP addresses are connected to physical locations at the country or city level around the world.',
      pool: 'Residential IP Pool',
      success: 'Connection Success Rate',
      coverage: 'Coverage Area',
      learnMore: 'Learn More'
    },
    useCases: {
      title: 'Full Scenario Support',
      desc: 'Meet your diverse business needs and help enterprises develop efficiently',
      dataCollection: 'Data Collection',
      brandProtection: 'Brand Protection',
      marketing: 'Digital Marketing',
      seo: 'SEO Monitoring',
      priceComparison: 'Price Comparison',
      security: 'Network Security',
      reviewMonitoring: 'Review Monitoring',
      adVerification: 'Ad Verification'
    },
    map: {
      title: 'Global Resource Network',
      desc: 'Daily updated active IPs over 90 million, 99% availability'
    },
    footer: {
      desc: 'Professional global big data proxy service provider, dedicated to providing high-quality proxy IP services to global users.',
      products: 'Products',
      support: 'Support',
      contact: 'Contact Us',
      copyright: 'Copyright © {year} xxxxproxy. All Rights Reserved.'
    }
  },
  staticProxy: {
    hero: {
      title: 'Static Residential Proxy',
      subtitle: 'Provide pure, stable, and exclusive real home broadband IP, suitable for long-term business scenarios',
    },
    features: {
      title: 'Core Advantages',
      speed: 'High Speed Network',
      speedDesc: 'High bandwidth and low latency, ensuring the ultimate speed of data scraping and access.',
      stability: 'Ultra High Stability',
      stabilityDesc: 'Enterprise-level server infrastructure, SLA 99.9% uptime.',
      location: 'Precise Location',
      locationDesc: 'Supports precise positioning at the country and city levels, meeting various regional restriction requirements.',
      ip: 'Pure Exclusive IP',
      ipDesc: 'Completely exclusive home residential IP, extremely high trust and anonymity.',
      pure: 'Safe and Reliable',
      pureDesc: 'Dual authentication methods of whitelist and account/password ensure your data security.',
      support: '7x24h Technical Support',
      supportDesc: 'Professional technical team is always on standby to solve any usage problems for you.'
    },
    pricing: {
      title: 'Pricing Plans',
      ip: ' IPs',
      unlimitedTraffic: 'Unlimited Traffic',
      exclusiveIP: 'Exclusive IP Resources',
    },
    useCases: {
      title: 'Use Cases',
      socialMedia: {
        title: 'Social Media Marketing',
        desc: 'Manage multiple social media accounts to avoid bans and increase brand exposure.'
      },
      eCommerce: {
        title: 'Cross-border E-commerce',
        desc: 'Stably access global e-commerce platforms, snap up limited-edition products, and conduct market analysis.'
      },
      marketResearch: {
        title: 'Market Research & Data Scraping',
        desc: 'Continuously and stably scrape competitor data, product prices, and industry trends to obtain real market intelligence.'
      },
      seo: {
        title: 'SEO Monitoring & Optimization',
        desc: 'Simulate real user search behavior in different regions, monitor keyword rankings, and optimize SEO strategies.'
      },
      adVerification: {
        title: 'Ad Verification & Delivery',
        desc: 'Verify ad display effects worldwide, prevent ad fraud, and ensure effective use of marketing budgets.'
      },
      brandProtection: {
        title: 'Brand & Copyright Protection',
        desc: 'Anonymously monitor infringement behaviors, protect intellectual property, and prevent unauthorized content distribution.'
      }
    },
    advantages: {
      title: 'Why Choose Our Static Residential Proxies?',
      items: [
        {
          title: '100% Real Home Broadband IPs',
          desc: 'All our static residential proxy IPs come from real home broadband users, not datacenter IPs. This means your access requests will be treated as normal visits by target websites, greatly reducing the probability of being identified as a bot or blocked.'
        },
        {
          title: 'Long-term Exclusive IP, Stable & Reliable',
          desc: 'Unlike dynamic proxies, static residential proxies provide fixed IP addresses that are completely exclusive to you during the subscription period. This is highly suitable for business scenarios that require maintaining a logged-in state with a fixed IP over a long period, such as social media account farming and e-commerce store operations.'
        },
        {
          title: 'Global Core Region Coverage',
          desc: 'We have deployed static residential proxy nodes in multiple core countries and cities worldwide, supporting precise geographic location selection, helping you easily bypass geographic restrictions to access exclusive content and services in specific countries or regions.'
        }
      ]
    }
  },
  purchase: {
    accountInfo: 'Account Information',
    currentPlan: 'Your current plan',
    noPlan: 'None',
    perGigabytePrice: 'Your per gigabyte price',
    whatTypeBroadband: 'What type of broadband do you need?',
    dynamicResidence: 'Dynamic Residence',
    needOverGB: 'Need more than a few GB of bandwidth?',
    buyPackage: 'Buy one of our packages at a more favorable price per GB',
    selectPackage: 'Select Package',
    discountPrice: 'Discount Price',
    confirm: 'Confirm',
    cancel: 'Cancel',
    loginWarning: 'Please login again!',
    pleaseSelectPackage: 'Please select a package'
  },
  dynamicProxy: {
    hero: {
      title: 'Dynamic Residential Proxy',
      subtitle: 'Over 90 million real residential IP resources worldwide, covering 195 countries/regions<br>High anonymity, high concurrency, fast response, helping business go global worry-free',
      buyNow: 'Buy Now',
      contactSales: 'Contact Sales'
    },
    features: {
      title: 'Why Choose Our Dynamic Residential Proxy?',
      successRate: '99.9% Success Rate',
      successRateDesc: 'Our IP pool is strictly screened and monitored in real-time to ensure extremely high connection success rates and stability.',
      concurrency: 'Unlimited Concurrent Sessions',
      concurrencyDesc: 'Supports massive concurrent requests to meet large-scale data collection and business expansion needs without speed limits.',
      location: 'Precise Targeting',
      locationDesc: 'Supports precise targeting at the country, city, and state/province levels to meet refined business scenario needs.',
      rotation: 'Auto-Rotate IP',
      rotationDesc: 'Supports rotation by request or setting sticky session duration, flexibly dealing with various anti-crawling strategies.',
      pure: 'Pure IP Resources',
      pureDesc: 'IPs from real home broadband users, high anonymity, extremely low blocking risk.',
      speed: 'Fast Response',
      speedDesc: 'Global distributed nodes, intelligent routing selection, ensuring the lowest latency access experience.'
    },
    pricing: {
      title: 'Flexible Pricing Plans',
      starter: 'Starter',
      pro: 'Professional',
      enterprise: 'Enterprise',
      startNow: 'Start Now',
      traffic: 'Traffic',
      unlimitedConcurrency: 'Unlimited Concurrency',
      countryLocation: 'Country Level Targeting',
      cityLocation: 'City Level Targeting',
      fullLocation: 'Full Location Targeting',
      authMode: 'API/Auth Mode',
      validity30: '30 Days Validity',
      validity90: '90 Days Validity',
      validityPermanent: 'Permanent Validity',
      exclusiveSupport: 'Exclusive Support'
    }
  },
  help: {
    hero: {
      title: 'Help Center',
      subtitle: 'Search documentation, tutorials, and FAQs'
    },
    tabs: {
      intro: 'Intro',
      pricing: 'Pricing',
      account: 'Account',
      troubleshoot: 'Troubleshoot'
    },
    contact: {
      title: 'Need more help?',
      desc: 'If you haven\'t found the answer to your question, please contact our support team.',
      contactUs: 'Contact Us'
    },
    faq: {
      q1: 'Why is there no network when using IP proxy?',
      a1: 'Overseas IPs need to be used in an overseas environment. If you are already in an overseas environment, please check if the server IP address is added to the whitelist.',
      q2: 'What is IP whitelist?',
      a2: 'IP whitelist is the verification mechanism of xxxxproxy. When using proxy services, you need to add the server IP using the proxy to the whitelist first. There are two forms:<br>(1) Local server uses proxy: After generating the link, the system will prompt to add the local server IP to the whitelist. After confirmation, you can use the proxy service.<br>(2) Other servers use proxy: Add IP whitelist in the xxxxproxy account background, supporting multiple IP whitelists.',
      q3: 'Which protocols does the IP support?',
      a3: 'Supports HTTP, HTTPS, SOCKS5 protocols.<br>The official website obtains HTTP and HTTPS, which are interoperable. Just set the request protocol directly when proxying; if you cannot obtain it, please contact customer service for assistance.',
      q4: 'What are the restrictions on IP usage?',
      a4: 'There are no request and concurrency limits for IPs. The API link extraction frequency is once per second, and a single IP extraction can reach up to 900. If there are other additional needs, contact customer service for assistance.',
      q5: 'Can I set up a proxy on my phone?',
      a5: 'Phones also need an overseas environment. Open the phone\'s WLAN settings, select the connected wireless network; click wireless network settings, click manual for proxy settings; manually enter the IP and port obtained in xxxxproxy.',
      q6: 'The obtained proxy IP is not the final export IP',
      a6: 'The IP is tunnel forwarding, the export is the real IP, the IP segment is consistent, the port is different, each port corresponds to an IP.',
      q7: 'How to check the local network?',
      a7: 'You can open cmd and enter curl ipinfo.io to view the current IP address.',
      q8: 'Can the xxxxproxy promotion plan be rewarded permanently?',
      a8: 'Unlike other promotion plans, xxxxproxy will not limit your reward cycle, permanent income!<br>(1) Recommend new users to try xxxxproxy for free, get 3 yuan/person cash reward!<br>(2) Recommend new users to buy and get 30% reward, up to 5000 yuan!<br>(3) If the user repurchases, you can enjoy a 5% reward for each order, up to 1000 yuan per transaction, earn rewards immediately!',
      q9: 'Which countries and regions does xxxxproxy cover?',
      a9: 'Currently covering more than 220 countries and regions including popular countries such as the United States, the United Kingdom, Canada, India, South Korea, etc.,<br>providing users with over 90 million IPs. Click here to learn more about countries and IP quantities.',
      q10: 'What proxy solutions does xxxxproxy provide?',
      a10: 'xxxxproxy currently provides the following 6 solutions:<br>Dynamic Residential, Static Residential, Exclusive Data Center, Dynamic Long-term ISP, Dynamic Data Center, Mobile Proxy.<br>In addition, we also provide "Web Unlock Tool", achieving a web crawler rate greater than 99.99%, sending requests with one click, and easily obtaining the most accurate data.',
      q11: 'What business scenarios can xxxxproxy proxies be used for?',
      a11: 'xxxxproxy proxies can be used in the following business scenarios:<br>Brand protection, ad verification, website testing, stock market data, market research, competitor intelligence, crawling indexing, email protection,<br>SEO monitoring optimization, travel information aggregation, etc. For which proxy your business is suitable for, you can consult the Account Manager for answers.',
      q12: 'How to test for free?',
      a12: 'New users register and perform real-name authentication. Add whitelist according to the usage process to test dynamic traffic for free. Personal authentication gets 30 yuan quota, free trial 230M traffic. Technical authentication gets 80 yuan quota, free trial 600M traffic. Enterprise authentication gets 150 yuan quota, free trial 1G traffic.',
      q13: 'How is the IP charged?',
      a13: 'Dynamic IP is charged according to traffic. The traffic calculation method is: upload + download, calculating the sum of uploaded traffic and downloaded traffic; Data Center IP and Static Residential are charged according to the number of IPs.',
      q14: 'The generated API link has no account identification, how to bill?',
      a14: 'Determined by the whitelist. Only when the server IP is in the whitelist list can the IP be obtained and used, otherwise the IP cannot be extracted. A whitelist IP can only be used in one account, and the traffic fee is deducted according to the account where the whitelist is located.',
      q15: 'Is invoicing supported?',
      a15: 'Contact customer service to issue electronic invoices. Paper invoices (special invoices) need to sign a purchase contract. Electronic invoices have no amount limit. The invoicing order is from large amount to small amount. Small amounts have timeliness and may be issued in the next month.',
      q16: 'Will fees be automatically deducted after the free gift traffic is used up?',
      a16: 'Fees will not be automatically deducted. After the free gift traffic is used up, proxies cannot be obtained. Only after purchasing a package or recharging, it will be charged according to the price.',
      q17: 'Does the quota package have a time limit? Will the quota be cleared?',
      a17: 'The quota package is obtained through account recharge, and the account quota has no time limit.<br>The 30-day validity period is the validity period of the billing unit price for the first use of the proxy during the first recharge. Within 30 days, fees are deducted according to the package discount unit price. After 30 days, fees are deducted according to the original price:<br>Dynamic Residential: 130￥/GB<br>Dynamic Data Center: 20￥/GB<br>Dynamic Long-term ISP: 130￥/GB',
      q18: 'What package types can be used after recharging the quota package?',
      a18: 'There are two ways to use the account quota:<br>1. Dynamic Residential/Dynamic Data Center/Dynamic Long-term ISP/Super Proxy, fees deducted according to proxy usage.<br>2. Static Residential/Exclusive Data Center, supports using account quota to purchase corresponding packages.',
      q19: 'If the IP expires, can I continue to use the same IP after renewal?',
      a19: 'IP cannot be renewed after expiration. Please pay attention to the expiration time and renew before the IP expires.',
      q20: 'Is there a traffic limit for Static Residential IP?',
      a20: 'Charged by quantity, no traffic limit.',
      q21: 'What is the difference between Exclusive Data Center and Dynamic Data Center?',
      a21: 'Both IPs come from IDC computer rooms, marked as computer room IPs.<br>Dynamic Data Center is charged by traffic, custom 1-30min IP duration, efficient rotation.<br>Exclusive Data Center is charged by IP quantity, is a long-term IP address for personal exclusive use, selectable weekly/monthly/quarterly or custom IP duration.',
      q22: 'What is the difference between Quota Package and Product Package?',
      a22: 'Product Package: Select Dynamic Residential, Static Residential, Data Center, Dynamic ISP or Mobile Proxy according to business needs. Package duration includes weekly, monthly, quarterly or custom duration. Traffic will be cleared when the package expires.<br>Quota Package: Choose recharge amount according to needs. The recharged amount can use all xxxxproxy proxy types.<br>Dynamic Residential/Dynamic Data Center/Dynamic Long-term ISP/Super Proxy, fees deducted according to proxy usage, pay as you go;<br>Static Residential/Exclusive Data Center, supports using account quota to purchase corresponding packages.',
      q23: 'Can unused traffic be rolled over to the next month?',
      a23: 'If you purchased a Dynamic Residential Monthly Package and the traffic is not used up within 1 month, it cannot be rolled over to the next month.<br>Please consider your usage before purchasing and choose a monthly package that suits you; if you purchased a Quota Package,<br>fees are deducted according to usage, and traffic usage has no time limit, pay as you go.',
      q24: 'Does xxxxproxy support city-level targeting?',
      a24: 'xxxxproxy supports precise city targeting in multiple countries. You can access target websites from specified countries and cities. For details, please consult the Account Manager.',
      q25: 'Does IP limit the number of terminal devices used?',
      a25: 'Dynamic is charged by traffic, and there is no limit on concurrency and simultaneous connections.',
      q26: 'How to use Auth & Secrets?',
      a26: 'Auth & Secrets distributes traffic by creating authentication accounts through the main account. Users can create multiple "authentication accounts", set traffic quotas for each authentication account, and use them flexibly according to business needs. For specific operations, refer to the "Auth & Secrets Tutorial".',
      q27: 'What happens if the server IP is added to the whitelist by multiple accounts?',
      a27: 'For example, if two accounts A and B use the same server at the same time, if the server IP is saved in account A, the traffic of account A will be deducted; if it is in account B, the traffic of account B will be deducted; if the server IP is already saved in account A, and account B adds it again, it will override the server IP retention of account A, and using traffic will deduct from account B.',
      q28: 'Can the IP generated by the link be used all the time?',
      a28: 'In API proxy mode, the server will be upgraded and maintained from time to time, and the IP and port will also change. It is not recommended to use the same IP segment for a long time. You can get a new one every few days. If it is Auth & Secrets proxy mode, it can be used all the time.',
      q29: 'The account has traffic, but the generated API link prompts insufficient quota',
      a29: 'Please check if the whitelist is added in the xxxxproxy account background. After adding the whitelist, get the API link again. If added, delete the whitelist and add it again, then get the API link again.',
      q30: 'How to judge whether the proxy is invalid through the program',
      a30: 'The official website background can set the IP duration. Dynamic can be set up to 30 minutes. The IP is tunnel forwarding and will automatically switch after failure.'
    }
  },
  dashboard: {
    auth: {
      trafficOverview: 'Traffic Overview',
      remainingTraffic: 'Remaining Traffic',
      remaining: 'Remaining',
      total: 'Total',
      credentials: 'Auth Credentials',
      resetPassword: 'Reset Password',
      host: 'Host',
      port: 'Port',
      user: 'User',
      pass: 'Pass',
      generator: 'Proxy Generator',
      generatorSubtitle: 'Configure and extract your dynamic residential proxy',
      location: 'Location',
      country: 'Country',
      region: 'Region',
      city: 'City',
      any: 'Any',
      settings: 'Settings',
      subAccount: 'Sub-account',
      quantity: 'Quantity',
      duration: 'Duration (min)',
      format: 'Format',
      select: 'Please select',
      rotationMode: 'Rotation Mode',
      sticky: 'Sticky IP',
      rotating: 'Rotation per Request',
      generate: 'Generate Proxy',
      copyAll: 'Copy All',
      download: 'Download File',
      copySuccess: 'Copied to clipboard',
      copyFail: 'Browser does not support copy',
      modifySuccess: 'Modification successful',
      relogin: 'Please login again!'
    },
    subaccount: {
      overview: 'Resource Overview',
      masterAvailable: 'Master Available',
      sonTotal: 'Sub-account Total',
      sonRemaining: 'Sub-account Remaining',
      actions: 'Quick Actions',
      create: 'New Sub-account',
      searchPlaceholder: 'Search username...',
      query: 'Query',
      listTitle: 'Account List',
      refresh: 'Refresh',
      totalItems: 'Total {total} items',
      columns: {
        username: 'Username',
        totalFlow: 'Total Flow',
        usedFlow: 'Used Flow',
        host: 'Host',
        port: 'Port',
        password: 'Password',
        createTime: 'Create Time',
        remark: 'Remark',
        action: 'Action'
      },
      topUp: 'Top Up',
      deduct: 'Deduct',
      editRemark: 'Edit Remark',
      delete: 'Delete',
      confirmDelete: 'Confirm Delete',
      cancel: 'Cancel',
      confirmDeleteMsg: 'Are you sure to delete account {username}?',
      createModal: {
        title: 'Create Sub-account',
        name: 'Account Name',
        namePlaceholder: 'Set username',
        password: 'Set Password',
        passwordPlaceholder: 'Set password',
        flow: 'Allocate Flow',
        flowPlaceholder: 'Enter flow amount'
      },
      topUpModal: {
        title: 'Add Flow',
        label: 'Add Flow',
        placeholder: 'Enter amount to add'
      },
      deductModal: {
        title: 'Deduct Flow',
        label: 'Deduct Flow',
        placeholder: 'Enter amount to deduct'
      },
      editModal: {
        title: 'Update Remark',
        label: 'Remark Content',
        placeholder: 'Enter new remark...'
      },
      msg: {
        fetchFail: 'Failed to fetch sub-account list',
        listLoadFail: 'List load failed',
        incomplete: 'Please fill in complete information',
        createSuccess: 'Created successfully',
        addFail: 'Add failed',
        createFail: 'Creation failed',
        updateSuccess: 'Update successful',
        modifyFail: 'Modification failed',
        updateFail: 'Update failed',
        invalidNum: 'Please enter a valid number',
        opSuccess: 'Operation successful',
        opFail: 'Operation failed',
        topUpFail: 'Top up failed',
        deductFail: 'Deduct failed',
        deleteFail: 'Delete failed',
        dataFail: 'Data fetch failed'
      }
    },
    traffic: {
      allAccounts: 'All Accounts',
      overview: 'Resource Overview',
      totalConsumption: 'Total Consumption',
      peakUsage: 'Peak Usage',
      control: 'Control Panel',
      switchView: 'Switch View',
      selectSubAccount: 'Select Sub-account',
      queryData: 'Query Data',
      trendAnalysis: 'Traffic Trend Analysis',
      refreshData: 'Refresh Data',
      chartTooltip: 'Traffic Consumption'
    }
  },
  countries: {
    us: 'USA',
    br: 'Brazil',
    de: 'Germany',
    fr: 'France',
    in: 'India',
    ca: 'Canada',
    gb: 'UK',
    es: 'Spain'
  },
  record: {
    flowChange: {
      title: 'Traffic Change Record',
      rechargeTime: 'Recharge Time',
      beforeFlow: 'Flow Before',
      changeFlow: 'Flow Change',
      afterFlow: 'Flow After'
    },
    login: {
      title: 'Login Record',
      username: 'Username',
      loginTime: 'Login Time',
      ip: 'IP Address',
      os: 'OS',
      browser: 'Browser'
    }
  },
  check: {
    title: 'Proxy Checker',
    desc: 'Quickly verify proxy server connectivity, anonymity, and export IP location',
    config: 'Configuration',
    proxyType: 'Proxy Type',
    queryChannel: 'Query Channel',
    proxyList: 'Proxy List',
    placeholder: 'Enter proxy info, format:\nIP:Port\nIP:Port:User:Pass',
    tip: 'Supports batch paste, max 20',
    startCheck: 'Start Check',
    checking: 'Checking...',
    guide: 'Supported Formats',
    hasPassword: 'With Password:',
    example: 'Example:',
    result: 'Check Results',
    total: 'Total {total} items',
    clear: 'Clear',
    empty: 'Please add proxy info on the left to check',
    columns: {
      info: 'Proxy Info',
      type: 'Type',
      exportIp: 'Export IP Info',
      status: 'Status'
    },
    status: {
      unchecked: 'Unchecked',
      checking: 'Checking',
      available: 'Available',
      unavailable: 'Unavailable',
      failed: 'Failed'
    },
    msg: {
      inputFirst: 'Please enter proxy info first'
    }
  },
  static: {
    selectCountry: 'Select Country',
    enterIP: 'Enter IP',
    remark: 'Remark',
    search: 'Search',
    reset: 'Reset',
    proxyFormat: 'Proxy Format',
    proxyType: 'Proxy Type',
    broadcast: 'Broadcast',
    native: 'Native',
    batchExport: 'Batch Export',
    batchRenewal: 'Batch Renewal',
    batchChangeAccount: 'Batch Change Account',
    renewal: 'Renewal',
    export: 'Export',
    changeAccount: 'Change Account',
    purchaseDuration: 'Purchase Duration',
    thirtyDays: '30 Days',
    enterRemark: 'Enter Remark',
    username: 'Username',
    enterUsername: 'Enter Username',
    proxyPassword: 'Proxy Password',
    enterPassword: 'Enter Password',
    connectionAddress: 'Connection Address',
    port: 'Port',
    creationTime: 'Creation Time',
    expirationTime: 'Expiration Time',
    ipLocation: 'IP Location',
    operation: 'Operation',
    total: 'Total {total} items',
    nativeStaticPurchase: 'Native Static Proxy Purchase',
    broadcastStaticPurchase: 'Broadcast Static Proxy Purchase',
    pleaseFillInfo: 'Please fill in the following information for proxy purchase',
    businessType: 'Business Type',
    businessTypeNote: 'Please confirm your business type before purchase to avoid usage issues',
    country: 'Country',
    pleaseSelectCountry: 'Please Select Country',
    city: 'City',
    pleaseSelectCity: 'Please Select City',
    inventory: 'Inventory',
    protocol: 'Protocol',
    http: 'Http',
    socks5: 'Socks5',
    protocolNote: 'Supports Http, Https, Socks5 protocols, default is fine',
    durationNote: 'Valid duration, renewal available upon expiration',
    purchaseQuantity: 'Purchase Quantity',
    paymentAmount: 'Payment Amount',
    integral: 'Integral',
    availableIntegral: 'Available Integral',
    rechargeIntegral: 'Recharge Integral',
    giftIntegral: 'Gift Integral',
    prioritizeRecharge: 'Prioritize recharge integral',
    pay: 'Pay',
    confirmOrder: 'Confirm Order',
    confirmPurchase: 'Confirm purchase of the current package?',
    userId: 'User ID',
    confirmRenewal: 'Confirm renewal?',
    paySuccess: 'Payment Successful',
    createFail: 'Failed to create static package, please contact administrator~',
    networkError: 'Network request error, please try again later',
    copySuccess: 'Copied to clipboard successfully',
    copyFail: 'This browser does not support copying',
    modifySuccess: 'Modification Successful',
    relogin: 'Please log in again!',
    pleaseSelectBusinessType: 'Please select the required business type',
    cityRequired: 'City is required',
    countryRequired: 'Country is required',
    protocolRequired: 'Please select a protocol',
    quantityRequired: 'Please select the purchase quantity',
    dontRepeatSubmit: 'Do not submit repeatedly'
  },
  user: {
    security: {
      title: 'Account Security',
      subtitle: 'Update your login password to protect your account assets',
      changePassword: 'Change Password',
      currentPassword: 'Current Password',
      currentPasswordPlaceholder: 'Enter current password',
      setNewPassword: 'Set New Password',
      newPassword: 'New Password',
      newPasswordPlaceholder: 'Set new login password',
      confirmPassword: 'Confirm Password',
      confirmPasswordPlaceholder: 'Enter again to confirm',
      confirmChange: 'Confirm Change',
      processing: 'Processing...',
      resetForm: 'Reset Form',
      tipsTitle: 'Security Tips',
      tip1: 'Use 8+ chars with letters and numbers',
      tip2: 'Do not use passwords used on other sites',
      tip3: 'Changing password regularly reduces risk',
      helpTitle: 'Need Help?',
      helpDesc: 'If you forgot your old password or have other issues, please contact support.',
      contact: 'Contact Support',
      msg: {
        incomplete: 'Please fill in complete information',
        mismatch: 'Passwords do not match',
        length: 'Password length at least 8 chars',
        success: 'Password changed, please login again',
        fail: 'Password change failed',
        error: 'System error, please try again later'
      }
    }
  }
};
